/* tslint:disable */
/* eslint-disable */

// @ts-ignore
import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// @ts-ignore
import type { ConfigurationParameters } from '../configuration';
// @ts-ignore
import { Configuration as OpenApiGeneratorConfiguration } from '../configuration';
// @ts-ignore
import type { AxiosError, AxiosResponse } from 'axios';
import {
    useQuery,
    UseMutationOptions,
    useMutation,
    UseQueryOptions
    // @ts-ignore
} from 'react-query';
// @ts-ignore
import { useAuthorizationToken, useAuthQueryKey, useApiBasePath } from '../../utils';
// Some imports not used depending on template conditions
// @ts-ignore
import {
    DUMMY_BASE_URL,
    assertParamExists,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    serializeDataIfNeeded,
    toPathString,
    createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { IcaoIataCode } from '../models';
/**
 * IcaoIataCodesWebServicesApi - axios parameter creator
 * @export
 */
export const IcaoIataCodesWebServicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAirlines: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/airlines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};

/**
 * IcaoIataCodesWebServicesApi - functional programming interface
 * @export
 */
export const IcaoIataCodesWebServicesApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = IcaoIataCodesWebServicesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAirlines(
            options?: AxiosRequestConfig
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IcaoIataCode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAirlines(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, configuration?.basePath, configuration);
        }
    };
};

/**
 * IcaoIataCodesWebServicesApi - factory interface
 * @export
 */
export const IcaoIataCodesWebServicesApiFactory = function (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) {
    const localVarFp = IcaoIataCodesWebServicesApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAirlines(options?: AxiosRequestConfig): AxiosPromise<Array<IcaoIataCode>> {
            return localVarFp.getAirlines(options).then(request => request(axios, basePath));
        }
    };
};

/**
 * IcaoIataCodesWebServicesApi - object-oriented interface
 * @export
 * @class IcaoIataCodesWebServicesApi
 * @extends {BaseAPI}
 */
export class IcaoIataCodesWebServicesApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IcaoIataCodesWebServicesApi
     */
    public getAirlines(options?: AxiosRequestConfig) {
        return IcaoIataCodesWebServicesApiFp(this.configuration)
            .getAirlines(options)
            .then(request => request(this.axios, this.basePath));
    }
}

// custom hook generation here
export type GetGetAirlinesResponse = AxiosResponse<Array<IcaoIataCode>>;
export const KeyGetGetAirlines = 'GetGetAirlines';
export const useMutationGetGetAirlines = (
    options?: UseMutationOptions<GetGetAirlinesResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();

    const res = useMutation<GetGetAirlinesResponse, AxiosError>(
        () =>
            new IcaoIataCodesWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath
                })
            ).getAirlines(axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
export const useQueryGetGetAirlines = (
    options?: UseQueryOptions<GetGetAirlinesResponse, AxiosError>,
    axiosConfig?: AxiosRequestConfig,
    conf?: ConfigurationParameters
) => {
    const basePath = useApiBasePath();
    const accessToken = useAuthorizationToken();
    const authQueryKey = useAuthQueryKey();

    const res = useQuery<GetGetAirlinesResponse, AxiosError>(
        [KeyGetGetAirlines, options && options.queryKey, authQueryKey],
        () =>
            new IcaoIataCodesWebServicesApi(
                new OpenApiGeneratorConfiguration({
                    accessToken,
                    basePath,
                    ...conf
                })
            ).getAirlines(axiosConfig),
        options
    );
    return { ...res, data: res.data?.data };
};
